import React, { useEffect, useState } from 'react';
import { PLATAFORMAS_API } from '../../../shared/services/plataformas';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../shared/helpers/functionalities';
import { CircularProgress } from '@mui/material';

const UpdateCfClearenceRF = () => {
    const [cfClearence, setCfClearence] = useState({
        newValue: '',
        current: '',
    });
    const [loading, setLoading] = useState(false);

    const getCurrentRFClearenceRequest = async () => {
        try {
            setLoading('current')
            const res = await PLATAFORMAS_API.getCurrentRFClearence();
            if (res?.success) {
                return setCfClearence((prev) => ({
                    ...prev,
                    current: res.data || '-',
                }));
            }
            toast.error('No se ha podido obtener el Clearence actual de RF');
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setLoading(false);
        }
    };

    const updateCfClearence = (value) => {
        setCfClearence((prev) => ({ ...prev, newValue: value }));
    };

    const submitSearch = async () => {
        if (!cfClearence.newValue) return;
        try {
            setLoading('newValue');
            const res = await PLATAFORMAS_API.udateRFClearence(
                cfClearence.newValue,
            );
            if (res?.success) {
                setCfClearence({ current: res.data, newValue: '' });
                return toast.success('Clearence de RF actualizado.');
            }
            toast.error('No se ha podido actualizar el Clearence de RF');
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (cfClearence.current) return;
        getCurrentRFClearenceRequest();
    }, []);

    return (
        <div className="d-flex flex-column align-items-center gap-3">
            <div className="w-100 d-flex flex-column align-items-start gap-1">
                <label htmlFor="current">VALOR ACTUAL:</label>
                <div className="position-relative w-100">
                    <input
                        id="current"
                        value={loading === 'current' ? 'Cargando...' : cfClearence.current}
                        className="form-control pe-5"
                        disabled
                    />
                </div>
            </div>
            <div className="w-100 d-flex flex-column align-items-start gap-1">
                <label htmlFor="newValue">VALOR NUEVO:</label>
                <input
                    id="newValue"
                    value={cfClearence.newValue}
                    name="newValue"
                    onChange={(e) => updateCfClearence(e.target.value)}
                    className="form-control"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            submitSearch();
                        }
                    }}
                />
                <button
                    onClick={() => submitSearch()}
                    className="btn btn-primary align-self-end mt-3 w-25"
                    style={{ height: '40px' }}
                >
                    {loading === 'newValue' ? (
                        <CircularProgress color="inherit" size={15} />
                    ) : (
                        'Actualizar'
                    )}
                </button>
            </div>
        </div>
    );
};

export default UpdateCfClearenceRF;
